import React from 'react';

export default function SectionTitle(props) {
    return(
        <section className="flex-center background-parallax bg-dark py-5" data-background="img/gallery/21.jpg"
                 data-overlay="black; .8">
            <div className="page-title-wrapper text-light">
                <h3 className="page-title">{props.title}</h3>
            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/SectionTitle.js